<template>
<div style="width:400px;margin:0 auto;margin-top:30px;padding-top:10px">
        <v-img
          :src="require('../assets/login.svg')"
          width="150"
          style="margin:0 auto;"
        ></v-img>
        <v-text-field
                type="number"
                style="min-width:300px;width:400px;margin:0 auto;height:60px;margin-top:10px;"
                label="Enter Mobile Number"
                solo
                v-model="phone"
              
          />
          <div style="width:100%;float:left">
            <v-btn @click="login" color="primary" style="min-width:300px;width:400px;margin:0 auto;">Submit</v-btn>
        </div>
        <v-dialog
                v-model="proccess"
                persistent
                width="300">
                        <v-card
                        color="primary"
                        dark>
                                <v-card-text>Please wait
                                        <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                        />
                                        
                        </v-card-text>
                </v-card>
        </v-dialog>
        <v-dialog
                v-model="otpcheck"
                persistent
                width="300" height="300">
                        <v-card >
                                <v-card-title>Enter OTP</v-card-title>
                                       <v-divider></v-divider>
                                        <v-card-text>
                                                <v-text-field
                                                type="number"
                                                style="width:200px;margin:0 auto;height:60px;"
                                                label="OTP"
                                                v-model="otp"
                                                solo
                                                />          
                                                <v-btn color="primary" @click="verify" style="width:200px;margin-left:35px">Submit</v-btn>
   
                                        </v-card-text>

                                </v-card>
        </v-dialog>
     </div>
</template>

<script>
export default {   
    data(){
            return{
                    proccess:false,
                    phone:"",
                    password:"",
                    otpcheck:false,
                    otp:"",
                    authkey:""
            }
    },
    methods:{
                notification(type,message){
                        this.$notify({
                                group: 'foo',
                                title: 'Important message',
                                text: message,
                                duration:5000, 
                                type:type               
                        })
                },
                login(){
                        let vm = this;
                        if(vm.phone=="") return vm.notification("error","Phone Number Required")
                        if(vm.phone.length!=10) return vm.notification("error","Valid Phone Number Required")                        
                        vm.proccess = true;
                        let doc={
                                'username':vm.phone,
                                'MobileNo':vm.phone,
                                'Password':vm.phone,
                                'city':'*',
                                'email':vm.phone,
                                'address':'*',
                                'companyname':'*',
                                'aadharno':'*',
                                'panno':'*',
                                'gstno':'*',
                                'state':'*',
                                'source':'json',
                                'user_subtype':'guest',
                                'authkey':'null'
                                }
                        vm.$store.dispatch("axiospost",{
                                url:"Registration",
                                data:doc,
                        }).then(function (res) {
                                vm.proccess = false;
                                console.log(res);                                
                                if(res.data.Status=="False")return vm.notification("error",res.data.Message);                                
                                if(res.data.Status=="SetOtp") {
                                        vm.otpcheck= true;
                                        vm.authkey = res.data.Message;
                                }
                                
                        }).catch(function (error) {
                                vm.notification("error",error);
                                vm.proccess = false;
                                
                        })

                },
                verify(){
                        let vm = this;
                        if(vm.otp=="") return vm.notification("error","OTP Required")                        
                        vm.proccess = true;
                        let doc = {
                                'MobileNo':vm.phone,
                                'Password':vm.phone,
                                'OTP':vm.otp,
                                'AuthKey':vm.authkey,
                                'Source':'json'
                        }
                        vm.$store.dispatch("axiospost",{
                                url:"Verify_Mobile_OTP",
                                data:doc,
                        }).then(function (res) {
                                vm.proccess = false;
                                vm.otpcheck= false;
                                console.log(res);                                
                                if(res.data.Status=="False"){
                                  vm.otpcheck= true;
                                  return vm.notification("error",res.data.Message);
                                }                                
                                if(res.data.Status=="True") {                                        
                                        vm.proccess = false;
                                        let doc = res.data.Data;
                                        doc.authkey = vm.authkey;
                                        doc.phone = vm.phone;
                                        doc.password = doc.Pin;
                                        localStorage.user = JSON.stringify(doc);
                                        vm.$store.dispatch("getuser");
                                        return vm.notification("success","Authentication Success")
                                }
                        }).catch(function (error) {
                                vm.notification("error",error);
                                vm.otpcheck= true;
                                vm.proccess = false;
                                
                        })
                },
    }
 }
</script>
